export default __webpack_public_path__ + "static/media/8922.21f29a40.svg";